import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";

import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAll,
  Delete,
  Status,
} from "../../../utils/apis/rummy/rummy_table_history/index";
import { Per_Page_Dropdown } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import RummyRoundHistory from "../../Common_Component/Common_Modal/Rummy_Round_History/rummy_round_history";
import RummyTableHistoryInnerRound from "../../Common_Component/Common_Modal/RummyTableHistoryInnerRound/RummyTableHistoryInnerRound";
import RummyTableHistoryInnerRoundCards from "../../Common_Component/Common_Modal/RummyTableHistoryInnerRoundCards/RummyTableHistoryInnerRoundCards";
import { useLocation } from "react-router-dom";

const Rummy_table_history_inner_page = () => {
  const { UnauthorizedLogOut, IMG_URL, isAllow } = useContext(Context);
  const [rummyWalletHistory, setRummyWalletHistory] = useState([]);
  const [showRummyWalletHistory, setShowRummyWalletHistory] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(0);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const getDataAll = async () => {
    try {
      const response = await findAll(currentPage, perPage, search);
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.page);
      setperPage(response?.data?.data?.limit);

      setOption(await Per_Page_Dropdown(response?.data?.data?.totalPages));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    search,
    changeStatus,
    perPage,
    reset,
    modalShow,
    modalEditShow,
    currentPage,
  ]);

  const StatusChange = async (id) => {
    const response = await Status(id);
    setChangeStatus(response);
  };

  const handleDeleteRecord = async () => {
    setModalDeleteShow(false);
    if (recordToDeleteId) {
      const response = await Delete(recordToDeleteId);

      await setShowModal({
        code: response.data.code,
        message: response.data.data,
      });

      setTimeout(() => {
        setShowModal(0);
      }, 2000);
      setRecordToDeleteId(null);
      setChangeStatus(response);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const location = useLocation();

  const { room_id, history } = location.state || {};

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Rummy Table Inner History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              {/* <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <br></br>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                    className="mt-1"
                  />
                </Form.Group>
              </div>{" "}
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setSearch("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div> */}
              {/* <div className=" col-12 mt-3">
                <div className="d-flex  align-items-center">
                  <div className="show me-2">
                    <p style={{ color: "white" }} className="show m-0">
                      Show
                    </p>
                  </div>
                  <div className="number me-2">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => setperPage(e.target.value)}
                    >
                      {option?.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="entries">
                    <p style={{ color: "white" }} className="show m-0">
                      entries
                    </p>
                  </div>

                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-6 col-sm-2 col-12">
                    <div className="sowing me-2 ms-5">
                      <p
                        style={{ color: "white" }}
                        className="show m-0"
                      >{`Showing ${Math.min(
                        (currentPage - 1) * perPage + 1
                      )} to ${Math.min(
                        currentPage * perPage,
                        data?.data?.total
                      )} of ${data?.data?.total} entries`}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      {/* <th>Room Id</th> */}
                      <th>Player Name</th>
                      <th>Amount</th>
                      <th>Win Status</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>History</th>
                    </tr>
                  </thead>

                  <tbody>
                    {history?.map((d, index) => {
                      return (
                        <tr>
                          <td>{(currentPage - 1) * perPage + index + 1}</td>
                          {/* <td> {room_id}</td> */}
                          <td> {d.name}</td>
                          <td>₹ {d.winning_amount}</td>
                          <td>
                            <span
                              className={
                                d.win_loss ? "text-success" : "text-danger"
                              }>
                              {d.win_loss ? "WIN" : "LOSS"}
                            </span>
                          </td>
                          <td>
                            {" "}
                            {new Date(d.createdAt).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}
                          </td>
                          <td>
                            {" "}
                            {new Date(d.createdAt).toLocaleString("en-IN", {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })}
                          </td>
                          <td>
                            <Button
                              className="rs-view-btn"
                              onClick={() => {
                                setShowRummyWalletHistory(true);
                                setRummyWalletHistory(
                                  d.RummyGameRoundHistories,
                                );
                              }}>
                              View
                            </Button>{" "}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                {/* <CustomPaginate
                  currentPage={data?.data?.page}
                  totalPages={data?.data?.totalPages}
                  handlePageChange={handlePageChange}
                /> */}
                {/* <Heading_Holder subtext={"Note:"} /> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Delete_Points_Modal
        show={modalDeleteShow}
        handleDeleteRecord={handleDeleteRecord}
        onHide={() => setModalDeleteShow(false)}
      />

      <RummyTableHistoryInnerRound
        onHide={() => setShowRummyWalletHistory(false)}
        show={showRummyWalletHistory}
        rummyWalletHistory={rummyWalletHistory}
        history={history}
      />
    </>
  );
};

export default Rummy_table_history_inner_page;
